<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label for="candidate-avatar">{{ $t('avatar') }}</label>
                    <app-input
                        id="candidate-avatar"
                        type="custom-file-upload"
                        :generate-file-url="false"
                        v-model="candidateForm.avatar"
                        :label="$t('change_image')"
                        :error-message="$errorMessage(formErrors, 'avatar')"
                    />
                </div>
            </div>
            <div class="col-md-6 col-lg-4">
                <app-form-group
                    :label="$t('name_romaji') + '<span class=\'text-danger ml-1\'>*</span>'"
                    type="text"
                    :placeholder="$placeholder('name_romaji', '')"
                    v-model="candidateForm.name_romaji"
                    :error-message="$errorMessage(formErrors, 'name_romaji')"
                />
            </div>
            <div class="col-md-6 col-lg-4">
                <app-form-group
                    :label="$t('name_katakana') + '<span class=\'text-danger ml-1\'>*</span>'"
                    type="text"
                    :placeholder="$placeholder('name_katakana', '')"
                    v-model="candidateForm.name_katakana"
                    :error-message="$errorMessage(formErrors, 'name_katakana')"
                />
            </div>
            <div class="col-md-6 col-lg-4">
                <app-form-group
                    :label="$t('email') + '<span class=\'text-danger ml-1\'>*</span>'"
                    type="email"
                    :placeholder="$placeholder('email', '')"
                    v-model="candidateForm.email"
                    :error-message="$errorMessage(formErrors, 'email')"
                />
            </div>
            <div class="col-md-6 col-lg-4">
                <app-form-group
                    :label="$fieldTitle('contact', 'number') + '<span class=\'text-danger ml-1\'>*</span>'"
                    type="tel-input"
                    id="wizard-contact-number"
                    :placeholder="candidateForm.phone ? $placeholder('contact', 'number') : $t('not_added_yet')"
                    v-model="candidateForm.phone"
                    :error-message="$errorMessage(formErrors, 'phone')"
                />
            </div>
            <div class="col-md-6 col-lg-4">
                <app-form-group-selectable
                    :label="$t('gender') + '<span class=\'text-danger ml-1\'>*</span>'"
                    type="select"
                    list-value-field="name"
                    :chooseLabel="$t('gender')"
                    :options="genderList"
                    v-model="candidateForm.gender"
                    :error-message="$errorMessage(formErrors, 'gender')"
                />
            </div>
            <div class="col-md-6 col-lg-4">
                <app-form-group-selectable
                    type="select"
                    :label="$t('residence') + '<span class=\'text-danger ml-1\'>*</span>'"
                    list-value-field="name"
                    v-model="candidateForm.residence"
                    :chooseLabel="$t('residence')"
                    :error-message="$errorMessage(formErrors, 'residence')"
                    :fetch-url="`${tenantBaseUrl}api/candidate/residence`"
                />
            </div>
            <div class="col-md-6 col-lg-4">
                <app-form-group-selectable
                    type="select"
                    :label="$t('clothing_size') + '<span class=\'text-danger ml-1\'>*</span>'"
                    list-value-field="name"
                    v-model="candidateForm.clothing_size"
                    :chooseLabel="$t('clothing_size')"
                    :error-message="$errorMessage(formErrors, 'clothing_size')"
                    :fetch-url="`${tenantBaseUrl}api/candidate/size`"
                />
            </div>
            <div class="col-md-6 col-lg-4">
                <app-form-group-selectable
                    type="select"
                    :label="$t('experience') + '<span class=\'text-danger ml-1\'>*</span>'"
                    list-value-field="name"
                    v-model="candidateForm.experience"
                    :chooseLabel="$t('experience')"
                    :error-message="$errorMessage(formErrors, 'experience')"
                    :options="experienceList"
                />
            </div>
            <div class="col-md-6 col-lg-4">
                <app-form-group-selectable
                    type="select"
                    :label="$t('years_in_japan')"
                    list-value-field="name"
                    v-model="candidateForm.in_japan"
                    :chooseLabel="$t('years_in_japan')"
                    :error-message="$errorMessage(formErrors, 'years_in_japan')"
                    :options="yearsInJapan"
                />
            </div>
            <div class="col-md-6 col-lg-4">
                <app-form-group
                    :label="$t('job_broker')"
                    type="text"
                    :placeholder="$placeholder('job_broker', '')"
                    v-model="candidateForm.job_broker"
                    :error-message="$errorMessage(formErrors, 'job_broker')"
                />
            </div>
            <div class="col-md-6 col-lg-4">
                <app-form-group
                    :label="$t('fb_link')"
                    type="text"
                    :placeholder="$placeholder('fb_link', '')"
                    v-model="candidateForm.fb_link"
                    :error-message="$errorMessage(formErrors, 'fb_link')"
                />
            </div>
            <div class="col-md-6 col-lg-4">
                <app-form-group
                    :label="$t('station') + '<span class=\'text-danger ml-1\'>*</span>'"
                    type="text"
                    :placeholder="$placeholder('station', '')"
                    v-model="candidateForm.station"
                    :error-message="$errorMessage(formErrors, 'station')"
                />
            </div>
            <div class="col-md-6 col-lg-4">
                <app-form-group
                    :label="$t('commuting_time') + '<span class=\'text-danger ml-1\'>*</span>'"
                    type="number"
                    :placeholder="$placeholder('commuting_time', '')"
                    v-model="candidateForm.how_long"
                    :error-message="$errorMessage(formErrors, 'how_long')"
                />
            </div>
            <template v-for="(field, index) in customFields" >
                <div v-if="field.type === 'textarea'" class="col-md-12" :key="index">
                    <app-form-group
                        type="textarea"
                        :text-area-rows="5"
                        label-alignment="top"
                        :label="fieldLabel(field)"
                        :placeholder="$textAreaPlaceHolder('remark')"
                        v-model="candidateForm[field.name]"
                        :error-message="$errorMessage(formErrors, field.name)"
                    />
                </div>
                <!-- <div  v-if="field.type === 'file'" class="col-md-12" :key="index">
                    <div class="form-group">
                        <label>{{ fieldLabel(field) }}</label>
                        <app-input
                            type="dropzone"
                            v-model="candidateForm[field.name]"
                            :error-message="$errorMessage(formErrors, field.name)"
                        />
                    </div>
                </div> -->
                <div v-else-if="field.type ==='select'" class="col-md-6 col-lg-4" :key="'select' + index">
                    <app-form-group-selectable
                        :id="'select' + field.name"
                        type="select"
                        :label="fieldLabel(field)"
                        list-value-field="value"
                        v-model="candidateForm[field.name]"
                        :chooseLabel="fieldLabel(field)"
                        :error-message="$errorMessage(formErrors, field.name)"
                        :options="field.options || []"
                    />
                </div>
                <div v-else class="col-md-6 col-lg-4" :key="'input' + index">
                    <app-form-group
                        :id="'input' + field.name"
                        :label="fieldLabel(field)"
                        :type="field.type"
                        :placeholder="$placeholder(fieldLabel(field).toLowerCase())"
                        :file-label="$placeholder('attachment', '')"
                        v-model="candidateForm[field.name]"
                        :error-message="$errorMessage(formErrors, field.name)"
                    />
                </div>
            </template>
            <div class="col-md-12">
                <div class="form-group">
                    <label>{{ $t('resume_work_history') }}</label>
                    <app-input
                        type="dropzone"
                        v-model="resumeFiles"
                        :error-message="$errorMessage(formErrors, 'files.0')"
                    />
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-between mt-4">
            <button type="button" class="btn btn-secondary" disabled>
                {{ $t('back') }}
            </button>
            <button type="button" class="btn btn-primary" @click="goNext" :disabled="isValidating">
                {{ $t('next') }}
            </button>
        </div>
    </div>
</template>

<script>
import FormHelperMixins from "../../../../../../common/Mixin/Global/FormHelperMixins";

export default {
    name: "CandidateProfileStep",
    mixins: [FormHelperMixins],
    props: {
        props: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isValidating: false,
        };
    },
    computed: {
        candidateForm() {
            return this.props.formData || {};
        },
        formErrors() {
            return this.props.errors || {};
        },
        tenantBaseUrl() {
            return this.props.tenantBaseUrl || '';
        },
        customFields() {
            return this.props.fields || [];
        },
        locate() {
            return this.props.locate || 'ja';
        },
        resumeFiles: {
            get() {
                return this.props.files || [];
            },
            set(value) {
                if (typeof this.props.onFilesChange === 'function') {
                    this.props.onFilesChange(value);
                }
            }
        },
        genderList() {
            return [
                {id: 'male', value: this.$t('male'), name: this.$t('male')},
                {id: 'female', value: this.$t('female'), name: this.$t('female')},
                {id: 'other', value: this.$t('other'), name: this.$t('other')}
            ];
        },
        experienceList() {
            return [
                {id: 0, name: this.$t('No')},
                {id: 1, name: this.$t('Yes')}
            ];
        },
        yearsInJapan() {
            return Array.from({length: 10}, (_, index) => {
                const value = index + 1;
                return {id: value, name: value};
            });
        },
        profileFields() {
            const baseFields = [
                'avatar',
                'name_romaji',
                'name_katakana',
                'email',
                'phone',
                'gender',
                'residence',
                'clothing_size',
                'experience',
                'in_japan',
                'job_broker',
                'fb_link',
                'station',
                'how_long',
                'files',
            ];

            const dynamicFields = this.customFields.map(field => field.name);

            return [...baseFields, ...dynamicFields];
        }
    },
    methods: {
        async goNext() {
            if (this.isValidating) {
                return;
            }

            const validateStep = this.props.validateStep;
            if (typeof validateStep === 'function') {
                this.isValidating = true;
                const isValid = await validateStep(this.profileFields);
                this.isValidating = false;

                if (!isValid) {
                    return;
                }
            }

            this.$emit('next', true);
        },
        fieldLabel(field) {
            return field?.label?.[this.locate] || field?.label?.ja || field?.label?.vi || '';
        }
    }
}
</script>
